import React, { useState, useEffect } from 'react';
import ModalCloseIcon from '@/components/general/ModalCloseIcon/ModalCloseIcon';
import { FlexContainer } from '@/components/containers/FlexContainer/FlexContainer';
import Label from '@/components/form/Label/Label';
import BotonPagoCulqi from '@/components/reusable/CulqiCheckout/CulqiCheckout';

const DetallesCitaMedicaModal = ({
  open,
  onClose,
  onOpenCancelModal,
  reportData,
  saveMedicalHistory,
}) => {
  const [isPaymentSuccess, setIsPaymentSuccess] = useState(false);

  const reportDataToSave = {
    codigo: reportData?.codigo,
    numero_de_historia_clinica: reportData?.numero_de_historia_clinica,
    pacientes_codigo: reportData?.numero_de_historia_clinica,
    personal_codigo: reportData?.personal?.codigo_personal,
    tipo_de_consulta: reportData?.tipo_de_consulta.codigo,
    monto_cobrado: reportData?.monto_cobrado,
    costo_de_consulta: reportData?.monto_cobrado,
    tipo_de_estado_codigo: reportData?.tipo_de_estado?.codigo,
    estado_de_horario: 'RESERVADO',
    fecha_de_atencion: reportData?.fecha_de_atencion,
    hora_de_atencion: reportData?.hora_de_atencion,
    fecha_de_registro: reportData?.fecha_de_registro,
    hora_de_registro: reportData?.hora_de_registro,
    tipo_de_reserva: 'EXTERNO',
    duracion_de_atencion: reportData?.duracion_de_atencion,
    fecha_de_reserva_atc: reportData?.fecha_de_registro,
    hora_de_reserva_atc: reportData?.hora_de_registro,
  };

  if (!open) return null;
  console.log('dsadsds_ ', reportDataToSave);
  const doctorName = reportData?.personal
    ? `${reportData.personal.abreviatura || ''} ${reportData.personal.nombres || ''}`
    : '—';
  const paciente = reportData.paciente || {};
  const nombrePaciente = paciente.nombres
    ? `${paciente.nombres} ${paciente.apellido_paterno || ''} ${paciente.apellido_materno || ''}`
    : 'Paciente prueba';
  const specialty = reportData?.personal?.especialidad || '—';

  const formatDate = (fecha) => {
    if (!fecha) return '—';

    const [year, month, day] = fecha.split('-').map(Number);
    const date = new Date(year, month - 1, day);

    return date.toLocaleDateString('es-PE', {
      weekday: 'long',
      day: '2-digit',
      month: 'long',
      year: 'numeric',
    });
  };

  const time = reportData?.hora_de_atencion ? reportData.hora_de_atencion.slice(0, 5) : '—';
  const state = reportData?.tipo_de_estado?.estado || 'ANULADA';
  const stateLabel = state.toUpperCase() === 'ATENDIDO' ? 'ATENDIDA' : state;
  const appointmentState = state?.toUpperCase();
  const isAttended = appointmentState === 'ATENDIDO';
  const isCanceled = appointmentState === 'ANULADA';
  console.log('HAS ', appointmentState);

  const date = formatDate(reportData?.fecha_de_atencion);

  console.log('ver', reportData);

  return (
    <FlexContainer
      className="pos-fixed justify-center align-center"
      style={{
        inset: 0,
        background: 'rgba(0,0,0,0.45)',
        zIndex: 9999,
        padding: 20,
      }}
    >
      <FlexContainer
        className="pos-rel flex-column width-680px m-format90 height-640px m-height-720px padtb26 padlr32"
        style={{
          borderRadius: '6px 6px 6px 6px',
          boxShadow: '0px 8px 22px rgba(0,0,0,0.15)',
          background: '#ffffff',
        }}
      >
        <FlexContainer
          onClick={onClose}
          className="pos-abs pointer top16 right16 width-38px height-38px text-22 align-items-center justify-center fontWhite"
          style={{
            background: '#023B7A',
            borderRadius: '50%',
            fontWeight: 'bold',
            boxShadow: '0px 3px 6px rgba(2,59,122,0.3)',
          }}
        >
          <ModalCloseIcon />
        </FlexContainer>

        <div className="width-580px height-600px m-format90 bgWhite borderrad20 padtb16 padlr10 pos-rel margb20 left40 m-left0 top10 m-margt20">
          <FlexContainer
            className="justify-between align-items-center padlr50 m-padlr0"
            style={{ marginBottom: '20px' }}
          >
            <FlexContainer className="flex-column">
              <Label
                className="text-20 fontBold"
                style={{
                  color: '#023B7A',
                  textAlign: 'left',
                  lineHeight: 1.2,
                }}
              >
                Cita médica
              </Label>

              <Label
                className="text-14 fontBold"
                style={{
                  color: '#6f8ec0',
                  textAlign: 'left',
                  lineHeight: 1.2,
                  marginTop: '2px',
                }}
              >
                Detalles de tu cita
              </Label>
            </FlexContainer>

            <Label
              className="text-12 fontBold borderrad20 pad6 padlr10"
              style={{
                color: '#6f8ec0',
                border: '1px solid #6f8ec0',
                textAlign: 'right',
                lineHeight: 1.2,
              }}
            >
              Tu cita está {stateLabel}
            </Label>
          </FlexContainer>

          <FlexContainer className="flex-column padlr50 m-padlr0 gap-16">
            <FlexContainer className="gap-12 align-items-center">
              <img
                src={'/doctors/' + reportData?.personal?.imagen}
                className="width-48px height-48px objectCover borderrad50"
              />
              <FlexContainer className="flex-column">
                <Label className="text-16 fontBold" style={{ color: '#023B7A' }}>
                  <strong> {doctorName}</strong>
                </Label>
                <Label className="text-12" style={{ color: '#7b7b7b' }}>
                  {specialty}
                </Label>
              </FlexContainer>
            </FlexContainer>

            <FlexContainer className="flex-column padlr60 m-padlr10">
              <Label className="text-12 fontBold" style={{ color: '#7B7B7B' }}>
                Paciente
              </Label>
              <Label className="text-16 fontBold" style={{ color: '#023B7A' }}>
                <strong> {nombrePaciente}</strong>
              </Label>
            </FlexContainer>

            <div style={{ borderBottom: '1px solid #D9D9D9', width: '100%' }}></div>

            <FlexContainer className="gap-10 align-items-center padlr60 m-padlr10">
              <i className="fas fa-calendar-alt" style={{ color: '#18489b', fontSize: '20px' }}></i>
              <Label className="text-16" style={{ color: '#023B7A', fontWeight: 600 }}>
                {date}
              </Label>
            </FlexContainer>

            <FlexContainer className="gap-10 align-items-center padlr60 m-padlr10">
              <i className="fas fa-clock" style={{ color: '#023B7A', fontSize: '20px' }}></i>
              <Label className="text-16" style={{ color: '#023B7A', fontWeight: 600 }}>
                {time}
              </Label>
            </FlexContainer>

            <div style={{ borderBottom: '1px solid #D9D9D9', width: '100%' }}></div>

            <FlexContainer className="gap-10 align-items-center padlr60 m-padlr10">
              <i
                className="fas fa-map-marker-alt"
                style={{ color: '#023B7A', fontSize: '20px', flexShrink: 0 }}
              ></i>
              <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                <Label
                  className="text-16 pointer"
                  style={{
                    color: '#023B7A',
                    fontWeight: 600,
                    textDecoration: 'underline',
                  }}
                >
                  Jr. Junín 142, Miraflores 15038
                </Label>
              </div>
            </FlexContainer>
            <div style={{ borderBottom: '1px solid #D9D9D9', width: '100%' }}></div>

            <FlexContainer
              className="bgLightBlue borderrad10 padt20 padlr40 padb20 text-12 m-text-8"
              style={{
                background: '#F0F7FF',
              }}
            >
              <ul
                style={{
                  margin: 0,
                  paddingLeft: 16,
                  color: '#023B7A',
                }}
              >
                <li>
                  Las cancelaciones o reprogramaciones con menos de 48 h de anticipación tendrán una
                  penalidad de S/50.
                </li>

                <li>
                  Si cuenta con resultados médicos, envíelos a<strong> archivos@drq.com.pe</strong>{' '}
                  48 h antes (incluya nombres completos).
                </li>

                <li>Se recomienda llegar con 10 minutos de anticipación.</li>

                <li>La reserva de la cita implica el pago total de la misma.</li>
              </ul>
            </FlexContainer>
          </FlexContainer>

          {isPaymentSuccess && (
            <FlexContainer
              className={'justify-center bgLightSage border-rad12px flex-container padtb10 margt10'}
            >
              <Label
                className="text-16 pointer justify-center"
                style={{
                  color: '#023B7A',
                  fontWeight: 600,
                }}
              >
                <strong>SU CITA FUE PAGADA CORRECTAMENTE</strong>
              </Label>
            </FlexContainer>
          )}

          {!isAttended && !isCanceled && (
            <FlexContainer className="justify-center gap-12 margt20 padlr90">
              <button
                className="width-150px height-40px text-12 borderrad10 pointer"
                style={{
                  background: '#fff',
                  color: '#f34d4e',
                  fontWeight: 700,
                  border: '1px solid #f34d4e',
                }}
                onClick={() => {
                  onClose();
                  onOpenCancelModal();
                  saveMedicalHistory(reportData, paciente);
                }}
              >
                Anular Cita
              </button>
              {/*
              <button
                className="width-150px height-40px borderrad10 pointer text-12"
                style={{
                  background: '#023B7A',
                  color: '#fff',
                  fontWeight: 700,
                  border: 'none',
                  boxShadow: '0px 2px 8px rgba(87,180,62,0.4)',
                }}
                onClick={onOpenRescheduleModal}
              >
                Reagendar una cita
              </button>
              */}

              {!isPaymentSuccess && (
                <BotonPagoCulqi
                  email={paciente?.correo_electronico}
                  jsonToPay={reportDataToSave}
                  setIsPaymentSuccess={setIsPaymentSuccess}
                />
              )}
            </FlexContainer>
          )}
        </div>
      </FlexContainer>
    </FlexContainer>
  );
};

export default DetallesCitaMedicaModal;
